import { createAPI } from "./create-api";
import auth from "./module/auth";
import { blobToText, showLoading, hideLoading } from "@/utils/utils";
import { message } from "ant-design-vue";
import router from "@/router";

const api = createAPI();
//请求拦截器
api.interceptors.request.use(
  (config) => {
    const noLoading = config.noLoading;
    if (!noLoading) {
      showLoading();
    }
    return config;
  },
  (error) => {
    const config = error.response?.config || {};
    const noLoading = config.noLoading;
    if (!noLoading) {
      hideLoading();
    }
    return Promise.reject(error);
  }
);

//响应拦截器
let goLoginFlagTimer = null;
api.interceptors.response.use(
  (response) => {
    // console.log(router.currentRoute.value.name)
    const config = response.config;
    const noLoading = config.noLoading;
    if (!noLoading) {
      hideLoading();
    }
    return response;
  },
  async (error) => {
    const status = error?.response?.status;
    if (status !== 200 && error?.response?.data instanceof Blob && error?.response?.data?.type === 'application/json') {
      const blobText = await blobToText(error.response.data);
      error.response.data = JSON.parse(blobText)
    }
    const config = error.response?.config || {};
    const noLoading = config.noLoading;
    if (!noLoading) {
      hideLoading();
    }
    switch (status) {
      case 400:
      case 403:
        const errorList = error?.response?.data;
        if (typeof errorList === "object") {
          errorList.forEach((errorMessage) => {
            message.error({
              content: errorMessage,
              class: "common-message-error"
            });
          });
        }
        break;
      case 401:
        const routeName = router.currentRoute.value.name;
        if (routeName !== "Login") {
          clearTimeout(goLoginFlagTimer);
          goLoginFlagTimer = setTimeout(() => {
            message.error({
              content: 'もう一度ログインしてください',
              class: "common-message-error"
            });
            router.replace({ name: "Login" });
          }, 200);
        }
        break;
      default:
        message.error({
          content: "予期できないエラーが発生しました。code:" + status,
          class: "common-message-error"
        });
        break;
    }
    return Promise.reject(error);
  }
);

export const authApi = auth(api);
